import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-app-terminoscondicionesbeneficios',
  templateUrl: './modal-app-terminoscondicionesbeneficios.component.html',
  styleUrls: ['./modal-app-terminoscondicionesbeneficios.component.scss'],
})
export class ModalAppTerminoscondicionesbeneficiosComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
